import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import '../css/BisharatMain.css';
import AuthService from "../services/AuthService";
import { MemberLinkBtn } from "../styles/Elements";
// import profileImg from '../data/images/profileImg.jpg';
// import logo from '../data/images/logo.png';
import translate from '../languages/translate';
const required = value => {
  if (!value) {
    return (
      <div className="alertDanger" role="alert">
        <p className="alertDanger">{translate("mandatory")}
          </p>
      </div>
    );
  }
};

const email = value => {
  if (!isEmail(value)) {
    return (
      <div className="alertDanger" role="alert">
        <p className="alertDanger">
      {translate("email-not-validated")}
       </p>
      </div>
    );
  }
};

const vpassword = value => {
  if (value.length < 8 || value.length > 40) {
    return (
      <div className="alertDanger" role="alert">
        <p>
          <ul>{translate("password-not-appropriate")}</ul>
          <ul> {translate("password-more-than-8")}</ul>
        </p>
      </div>
    );
  }
};

export default class Register extends Component {
  constructor(props) {
    super(props);
    this.handleRegister = this.handleRegister.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);

    this.state = {
      email: "",
      password: "",
      successful: false,
      message: ""
    };
  }

  onChangeEmail(e) {
    this.setState({
      email: e.target.value
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }

  handleRegister(e) {
    e.preventDefault();

    this.setState({
      message: "",
      successful: false
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      AuthService.register(
        this.state.email,
        this.state.password
      ).then(
        response => {
          this.setState({
            message: response.data.message,
            successful: true
          });
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            successful: false,
            message: resMessage
          });
        }
      );
    }
  }

  render() {
    const loggedInUser = AuthService.getCurrentUser();
    const handleLogout = () => {
      AuthService.logout();
      window.location = '/';
    }
    return (

      <div className='top-level-page-main login-page'>
        <div className="top-container-login">
          <div className="login-log">
            {loggedInUser ?
              <div className="loggedIn">
                <h3> {translate("already-logged")} {loggedInUser.username}</h3>
                <button className="btn" onClick={handleLogout}> {translate("logout")}</button>
                <a href="/" className="btn">{translate("back-to-main")} </a>
              </div> :

              <div>
                {/* <img src={profileImg}  alt="profile-img"/> */}
                <Form
                  onSubmit={this.handleRegister}
                  ref={c => {
                    this.form = c;
                  }}
                >
                  {!this.state.successful && (
                    <div>
                      <div className="form-group">
                        <label htmlFor="email"> {translate("email")}</label>
                        <Input
                          type="text"
                          className="form-control-register"
                          name="email"
                          value={this.state.email}
                          onChange={this.onChangeEmail}
                          validations={[required, email]}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="password">{translate("password")} </label>
                        <Input
                          type="password"
                          className="form-control-register"
                          name="password"
                          value={this.state.password}
                          onChange={this.onChangePassword}
                          validations={[required, vpassword]}
                        />
                      </div>

                      <div className="form-group">
                        <p className="alertSuccess">{translate("alert-email-sent")}</p>
                        <button className="btn btn-primary btn-block">{translate("join")}</button>
                        <a href="/" className="btn"> {translate("back-to-main")}</a>
                      </div>
                    </div>
                  )}

                  {this.state.message && (
                    <div>
                      <div className="form-group">
                        <div
                          className={
                            this.state.successful
                              ? "alertSuccess"
                              : "alertDanger"
                          }
                          role="alert"
                        >
                          {this.state.successful ? 
                         <> 
                          <p>{translate("check-ur-namil")}</p>
                          
                          <br></br>
                          {/* <p>في حال لم تستقبل اي بريد الكتروني, اضغط "ارسل مرة اخرى" لتلقي لارسال رابط التفعيل مرة اخرى</p>
                          <button  onClick={() => this.handleRegister()} className="btn btn-primary btn-block"> </button> */}
                          </>
                         :
                            <p>
                              {this.state.message}
                            </p>
                          }

                        </div >
                        <MemberLinkBtn to={'/login'}> {translate("back")} </MemberLinkBtn>
                      </div>
                    </div>
                  )}
                  <CheckButton
                    style={{ display: "none" }}
                    ref={c => {
                      this.checkBtn = c;
                    }}
                  />
                </Form>

              </div>
            }
          </div>


        </div>
      </div>
    );
  }
}